
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.12278',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.12278",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.466",
  "data-fetching-client": "static-1.9675",
  "foundations-components": "static-1.7949",
  "foundations-components-legacy": "static-1.974",
  "foundations-theming": "static-1.4423",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.82",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8019",
  "hub-http-shared-msw-handlers": "static-1.9973",
  "hubspot-dlb": "static-2.1854",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11477",
  "I18n": "static-7.1628",
  "jasmine-runner": "static-1.6470",
  "marketplace-storefront-base": "static-1.12339",
  "quartz": "static-1.7040",
  "react-dlb": "static-1.79",
  "react-rhumb": "static-1.16678",
  "reactive-variable-buffer-atom": "static-1.2864",
  "reporting-testing-lib": "static-1.9500",
  "settings-ui-lib": "static-1.12527",
  "SharedI18nStrings": "static-1.182",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7150",
  "ui-addon-i18n": "static-1.11155",
  "ui-addon-react-router-dom": "static-1.9548",
  "unified-auth": "static-1.499",
  "unified-auth-core-lib": "static-1.781",
  "usage-tracker": "static-1.7350",
  "usage-tracker-core": "static-1.7200",
  "customer-data-property-utils": "static-1.8096",
  "hub-http": "static-1.6228",
  "integrations-lib": "static-1.16154",
  "marketplace-ui-common": "static-1.19727",
  "property-management-iframe": "static-1.13164",
  "quartz-config": "static-1.818",
  "quartz-core": "static-1.6259",
  "quartz-routing": "static-1.470",
  "quick-fetch": "static-1.3920",
  "react": "static-7.186",
  "rpc-client-utils": "static-1.4658",
  "ts-schema": "static-1.4083",
  "ui-universal-auth": "static-1.8985",
  "UIComponents": "static-3.8423",
  "apollo-stack-hubspot": "static-3.84",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.79",
  "metrics-js": "static-1.9637",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3402",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3317",
  "quartz-webpack": "static-1.3264",
  "bend-plugin-quartz-routing": "static-1.118",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4218",
  "floating-ui": "static-1.56",
  "foundations-assets": "static-1.4871",
  "foundations-theming-specialty": "static-1.2139",
  "framer-motion": "static-1.72",
  "hs-story-utils": "static-1.9431",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.26",
  "react-select-plus": "static-1.105",
  "react-utils": "static-2.5348",
  "react-virtualized": "static-2.99",
  "StyleGuideUI": "static-3.487",
  "tanstack-table": "static-1.55",
  "trellis-assets": "static-1.1962",
  "ui-fonts": "static-1.739",
  "ui-images": "static-2.1156",
  "bend-plugin-foundations-theming": "static-1.2906",
  "foundations-theming-base": "static-1.3408",
  "stylex": "static-1.33",
  "HeadJS": "static-2.762",
  "hs-test-utils-bend-plugin": "static-1.3130",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4333",
  "ai-components-ui-library": "static-1.8995",
  "ai-rendering-library": "static-1.10188",
  "chirp-fetch": "static-1.1894",
  "connections-embed-lib": "static-1.1003",
  "copilot-toolkit": "static-1.11149",
  "feedback-loader": "static-1.29308",
  "laboratory-lib": "static-3.7162",
  "marketplace-embed": "static-1.22099",
  "marketplace-ui-details": "static-1.9623",
  "marketplace-ui-reviews": "static-1.19683",
  "marketplace-ui-tracking": "static-1.13898",
  "sanitize-text": "static-1.8148",
  "ui-addon-video-player": "static-1.8709",
  "usage-tracker-multi": "static-1.5764",
  "usage-tracker-session-replay": "static-1.5036",
  "wootric-nps": "static-1.6982",
  "quartz-head": "static-1.705",
  "web-vitals": "static-1.5",
  "apollo-link-hub-http": "static-2.4657",
  "immer": "static-1.33",
  "immerable": "static-1.4161",
  "highcharts": "static-8.104",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2499",
  "reporting-data": "static-1.67567",
  "cssUtils": "static-1.794",
  "flux-actions": "static-1.338",
  "HubStyle": "static-2.11784",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10213",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10371",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7340",
  "icons": "static-2.647",
  "marketplace-ui-apps-core": "static-1.18260",
  "storybook-react": "static-1.33",
  "trellis-story-utils": "static-1.4522",
  "foundations-components-test-utils": "static-1.5432",
  "quartz-i18n": "static-1.715",
  "react-input-autosize": "static-2.17",
  "google-sheets-integration-lib": "static-1.247",
  "microsoft-drive-integration-lib": "static-1.366",
  "slack-ui-library": "static-1.10399",
  "fsm": "static-1.3736",
  "customer-data-objects": "static-1.7675",
  "property-translator": "static-1.5407",
  "hs-locale-management": "static-1.84",
  "frontend-preferences-client": "static-1.7934",
  "hs-promise-utils": "static-1.5598",
  "hubspot-apollo-client": "static-1.4885",
  "integrations-error-boundary-lib": "static-1.13569",
  "integrations-tracking-lib": "static-1.5607",
  "native-integrations-shared-strings": "static-1.7788",
  "reselect": "static-2.16",
  "sanitize": "static-1.4483",
  "superstore": "static-1.4767",
  "ui-shepherd-react": "static-3.10169",
  "ai-settings-ui-library": "static-1.7897",
  "hub-http-janus": "static-1.836",
  "hubspotter-http": "static-1.4655",
  "immutable-less": "static-1.4660",
  "marketplace-ui-client-types": "static-1.17134",
  "nav-meta": "static-1.29696",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10254",
  "ui-addon-upgrades": "static-9.18003",
  "inbound-db-properties-service-client": "static-1.3849",
  "property-management-common": "static-1.5452",
  "ui-addon-iframeable": "static-1.9064",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.536",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.715",
  "quartz-test": "static-1.715",
  "quartz-tracking": "static-1.419",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.68",
  "bender-build-tools": "static-1.3205",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.21351",
  "ContentUtils": "static-1.68375",
  "customer-data-objects-ui-components": "static-1.13033",
  "sassPrefix": "static-1.156",
  "avatar-components": "static-1.2502",
  "customer-data-filters-ui": "static-1.39794",
  "customer-data-reference-ui-components": "static-1.13170",
  "embedded-academy-lib": "static-1.14364",
  "ExportDialog": "static-6.10395",
  "highlight.js": "static-1.79",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.41321",
  "reporting-snowflake": "static-1.56185",
  "reporting-ui-components": "static-2.64838",
  "reporting-visualizations": "static-1.59643",
  "ui-addon-teams": "static-1.21561",
  "magpie-lib": "static-1.5555",
  "navigation-components": "static-1.18059",
  "magpie-types": "static-1.5015",
  "simple-logging-lib": "static-1.3056",
  "ai-studio-lib": "static-1.11623",
  "app-governance-lib": "static-1.1549",
  "developer-experience-shared-components": "static-1.10515",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.8004",
  "ui-product-approvals": "static-1.28154",
  "ui-tool-access": "static-1.10153",
  "usage-based-billing-components-lib": "static-1.8905",
  "usage-tracker-anonymous": "static-1.5767",
  "usage-tracker-public": "static-1.7161",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3589",
  "persist-promise": "static-1.3704",
  "reference-resolvers": "static-1.8177",
  "ui-extensibility-client-types": "static-1.3931",
  "hubspot-apollo-cache": "static-1.344",
  "universal-page-editor-lib": "static-1.3018",
  "final-form": "static-1.70",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2789",
  "merchandise-lib": "static-1.264",
  "atom": "static-1.5078",
  "purchase-motions-components": "static-1.5913",
  "salesImages": "static-1.525",
  "batch-promise": "static-1.1547",
  "crm-component-utils": "static-1.39086",
  "crm-properties-common-lib": "static-1.5891",
  "customer-data-properties": "static-1.51564",
  "framework-data-schema-resolvers": "static-1.6891",
  "property-value-citations": "static-1.2178",
  "reference-resolvers-lite": "static-1.8100",
  "ui-business-units-lib": "static-1.9061",
  "navigation-messaging": "static-1.7386",
  "hubspotter-http-shared-msw-handlers": "static-1.9971",
  "cms-field-types": "static-1.4818",
  "content-icons-ui": "static-1.2229",
  "customer-data-ui-utilities": "static-1.9833",
  "events-data-lib": "static-1.227",
  "conversations-skeleton-state": "static-1.7253",
  "crm-message-bus": "static-1.43000",
  "customer-data-filters-ui-msw-helpers": "static-1.22229",
  "FormUrlGenerator": "static-2.4725",
  "framework-builder-read-service-client": "static-1.4008",
  "framework-data-schema-quick-fetch": "static-1.6796",
  "multi-account-reference-resolvers": "static-1.986",
  "onboarding-tours": "static-1.16620",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13693",
  "academy-common-lib": "static-1.13824",
  "content-assistance-lib": "static-1.7762",
  "dashboard-lib": "static-1.81550",
  "file-manager-components": "static-1.23643",
  "getting-started-shared-tasks": "static-1.18477",
  "hubspot-prosemirror": "static-1.18243",
  "hubspot-prosemirror-plugins": "static-1.18235",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19849",
  "share-with-third-party-component-lib": "static-1.8708",
  "ui-addon-draggable": "static-3.4768",
  "ui-asset-management-lib": "static-1.11041",
  "user-context": "static-1.5111",
  "growth-payments-core": "static-1.25389",
  "reporting-plugins": "static-1.10336",
  "reporting-reports": "static-1.67245",
  "idb-keyval": "static-1.44",
  "reactive-lib": "static-1.730",
  "nest": "static-1.232",
  "codemirror": "static-5.95",
  "react-codemirror": "static-1.10633",
  "framework-listing-lib": "static-2.28716",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30726",
  "apps-service-types": "static-1.3884",
  "oauth-service-types": "static-1.4255",
  "ui-product-approvals-common": "static-1.49",
  "onboarding-scopes": "static-1.6468",
  "onboarding-tours-client": "static-1.4834",
  "platform-infra-nav-components": "static-1.7672",
  "subscription-experience-data-types": "static-1.14944",
  "crm-record-cards-service-types": "static-1.3600",
  "location-customization-utils-lib": "static-1.9271",
  "redux-thunk": "static-2.43",
  "purchase-motions-api": "static-1.5916",
  "signup-constants": "static-1.18848",
  "signup-ui-url-generator": "static-2.8055",
  "trials-service-types": "static-1.3909",
  "card-properties-lib": "static-1.44203",
  "commerce-subscription-lib": "static-1.37129",
  "crm-actions": "static-1.6331",
  "crm-cards-sdk": "static-1.43596",
  "customer-data-properties-shared-msw-handlers": "static-1.9300",
  "customer-data-tracking": "static-1.6895",
  "hs-resources": "static-1.156",
  "pulse": "static-1.580",
  "calling-global-api": "static-1.64523",
  "calling-internal-common": "static-1.31309",
  "calling-lifecycle-internal": "static-1.65905",
  "calling-lifecycle-messages": "static-1.58199",
  "commerce-products-lib": "static-1.9579",
  "conditional-properties-service-client": "static-1.3800",
  "crm-links": "static-1.6300",
  "external-options-client-types": "static-1.4162",
  "google-libphonenumber": "static-1.38",
  "inbounddb-objects-service-types": "static-1.4226",
  "meetings-icalendar-utils-lib": "static-1.637",
  "multi-currency-client-types": "static-1.3694",
  "object-builder-ui-client": "static-1.48759",
  "pipeline-validation-client-types": "static-1.3968",
  "smart-property-lib": "static-1.7067",
  "tiered-pricing": "static-1.1233",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.10996",
  "crm-pipelines-api-client-types": "static-1.4142",
  "fdsr-migration-layer": "static-1.10",
  "react-dnd-compat": "static-1.4621",
  "react-immutable-render-mixin": "static-1.9",
  "restore-request-side-panel-lib": "static-1.905",
  "growth-data-modal": "static-1.5440",
  "growth-onboarding-confetti": "static-1.3072",
  "growth-onboarding-next-action-utils": "static-1.1929",
  "onboarding-tours-utils": "static-1.686",
  "ui-shepherd-tracker": "static-1.7550",
  "academy-service-client": "static-1.3687",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.39142",
  "FileManagerLib": "static-1.39283",
  "video-embed": "static-1.35770",
  "ui-coaching-tips": "static-1.28567",
  "redux-actions": "static-3.7",
  "video-components-external": "static-1.11278",
  "video-data-lib": "static-1.34936",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23547",
  "ui-addon-emoji-picker": "static-1.9894",
  "EmailSignatureEditor": "static-1.24384",
  "viral-links-lib": "static-1.7068",
  "data-token-picker": "static-1.16422",
  "react-flip-move": "static-1.70",
  "nested-table": "static-1.233",
  "timezone-utils": "static-2.5250",
  "seat-types-lib": "static-1.20",
  "getting-started-shared-tasks-store": "static-1.17595",
  "ui-addon-opt": "static-4.8374",
  "campaign-roi-lib": "static-1.9132",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7332",
  "customer-data-views-management": "static-1.25465",
  "framework-data-table": "static-2.11933",
  "marketing-platform-lib": "static-1.6864",
  "nudge-client-utils": "static-1.2593",
  "nudge-custom-ui-functions": "static-1.1036",
  "app-users-service-client": "static-1.5604",
  "app-users-service-types": "static-1.5012",
  "mini-checkout-client": "static-1.26824",
  "onboarding-utils": "static-1.5359",
  "permissions-shared-i18n-strings-fe": "static-1.2046",
  "ui-coaching-tips-shared-config": "static-1.28552",
  "edison-service-client-types": "static-1.394",
  "crm_data": "static-4.91978",
  "customer-data-sidebar": "static-2.46025",
  "enrichment-properties-lib": "static-1.16185",
  "ui-addon-draggable-compat": "static-2.4262",
  "commerce-billing-lib": "static-1.19077",
  "commerce-shared-components-lib": "static-1.18549",
  "commerce-tools-ui-lib": "static-1.10384",
  "crm-fe-perf": "static-1.22909",
  "bend-plugin-pulse": "static-1.83",
  "directed-graph": "static-1.942",
  "event-emitter": "static-1.954",
  "fast-json-patch": "static-1.63",
  "calling-error-reporting": "static-1.31316",
  "shared-worker-versioning": "static-1.11042",
  "calling-usage-tracker": "static-1.6547",
  "voice-sms-access-library": "static-1.987",
  "commerce-permissions": "static-1.775",
  "products-iframe-lib": "static-1.7943",
  "products-ui-components-shared-msw-handlers": "static-1.10355",
  "data-agent-kit": "static-1.202",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10056",
  "policy-lib": "static-1.6784",
  "react-tinymce": "static-1.55252",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10119",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54378",
  "tinymce-plugins": "static-1.57492",
  "tinymce-themes": "static-1.56348",
  "onboarding-data-sync-lib": "static-1.1969",
  "growth-onboarding-next-action-components": "static-1.1957",
  "user-context-client": "static-1.4619",
  "audio-components": "static-1.5925",
  "cropperjs": "static-1.10",
  "FileManagerImages": "static-1.36794",
  "urlinator": "static-1.4543",
  "video-components": "static-1.13281",
  "outpost": "static-1.4188",
  "growth-onboarding-feedback-components": "static-1.6587",
  "content-media-composition-data-lib": "static-1.12312",
  "content-media-compositions": "static-2.16319",
  "media-bridge-lib": "static-1.18939",
  "commerce-tours-lib": "static-1.6111",
  "growth-onboarding-reliability": "static-1.5088",
  "sales-checkout-service-client": "static-1.3646",
  "draft-convert": "static-2.73",
  "draft-extend": "static-3.75",
  "draft-js": "static-5.78",
  "draft-plugins": "static-2.21692",
  "sales-email-signature-service-client": "static-1.3849",
  "ts-utils-lib": "static-1.179",
  "breeze-engine-lib": "static-1.665",
  "crm-export-dialog": "static-1.6300",
  "crm-index-associations-lib": "static-1.6447",
  "crm-view-components": "static-1.260",
  "react-beautiful-dnd": "static-1.13",
  "tanstack-virtual": "static-1.30",
  "nudge-custom-function-registry": "static-1.2350",
  "nudge-renderer-utils": "static-1.2669",
  "whisper-core-api": "static-1.6631",
  "InboxConnectUtils": "static-4.14822",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5558",
  "settings-content-modals": "static-1.46090",
  "crm_universal": "static-1.22022",
  "customer-data-email": "static-1.18049",
  "card-payment-highlight-lib": "static-1.37186",
  "card-subscription-highlight-lib": "static-1.39552",
  "commerce-contract-lib": "static-1.12067",
  "invoices-highlight-card-lib": "static-1.54739",
  "orders-highlight-card-lib": "static-1.21479",
  "products-highlight-card-lib": "static-1.17862",
  "quotes-highlight-card-lib": "static-1.72057",
  "crm-source-interpretation-lib": "static-1.5349",
  "utility-belt": "static-1.2541",
  "payments-enrollment-embed-lib": "static-1.22887",
  "stripe-embedded-components": "static-1.7520",
  "customer-data-rte": "static-1.33005",
  "cv-backend-services": "static-1.1552",
  "growth-onboarding-empty-states": "static-1.5740",
  "payments-post-enroll-local-storage-lib": "static-1.5114",
  "qrcode-generator": "static-1.69",
  "quotes-client-types": "static-1.38147",
  "calling-orchestration-schema": "static-1.35764",
  "sales-views-client-types": "static-1.4265",
  "hub-http-contrib": "static-1.3049",
  "interframe": "static-3.4766",
  "tinymce-data": "static-1.40463",
  "ui-addon-sales-email": "static-1.5217",
  "layout-dnd-components": "static-1.12462",
  "layout-dnd-utils": "static-1.11437",
  "ui-brand-identity-lib": "static-1.15293",
  "NamespacedHubStyle": "static-2.9062",
  "meetings-connect-utils-lib": "static-1.7611",
  "social-insights-client-types": "static-1.22122",
  "js-cookie": "static-1.18",
  "ably": "static-2.2",
  "crm-index-visualization-core": "static-1.4146",
  "checkout-sdk": "static-3.23667",
  "checkout-service-types": "static-1.3824",
  "company-details-components": "static-1.6202",
  "payment-method-components": "static-1.6914",
  "pricing-pages-ui-components": "static-1.14025",
  "quote-checkout-service-types": "static-1.3473",
  "upgrade-catalog-service-types": "static-1.3526",
  "access-control-lib": "static-1.10442",
  "EmailComponents": "static-1.54755",
  "EmailData": "static-1.53432",
  "redux-less": "static-2.9489",
  "sequences-lib": "static-1.8056",
  "ui-gdpr-components": "static-1.10356",
  "products-ui-components": "static-1.40097",
  "accounting-integrations-ui-components": "static-1.7077",
  "invoices-ui-lib": "static-1.54755",
  "commerce-products-api": "static-1.2304",
  "invoices-iframe-lib": "static-1.56813",
  "quotes-modal-lib": "static-1.102735",
  "quotes-ui-lib": "static-1.80778",
  "stripe-connect-js": "static-1.68",
  "draft-content-plugins": "static-1.28276",
  "ContentData": "static-1.68450",
  "layout-data-lib": "static-1.9762",
  "hub-http-rxjs": "static-1.802",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3945",
  "billing-payments-client-types": "static-1.3995",
  "react-performance-metrics-lib": "static-1.561",
  "account-and-billing-fintech-outages": "static-3.18598",
  "pricing-pages-api": "static-1.13890",
  "ContentComponents": "static-2.71331",
  "marketing-contacts-lib": "static-1.10054",
  "marketing-email-service-types": "static-1.1919",
  "messaging-editing-lib": "static-1.46285",
  "messaging-usage-based-billing-components-lib": "static-1.1147",
  "automation-ui-source-apps": "static-1.18900",
  "automation-ui-types": "static-1.19818",
  "messaging-types-lib": "static-1.46022",
  "onboarding-settings-client": "static-1.4511",
  "sequences-client-types-lib": "static-1.7913",
  "commerce-tax-lib": "static-1.533",
  "price-books-api": "static-1.747",
  "price-books-components": "static-1.805",
  "property-description-translator": "static-1.3851",
  "ramp-editor": "static-1.167",
  "commerce-analytics-service-client": "static-1.3634",
  "totals-ui-components": "static-1.23608",
  "SalesContentIndexUI": "static-3.9258",
  "advanced-menus-core": "static-1.15139",
  "advanced-menus-lib": "static-1.12078",
  "ui-memberships-settings-lib": "static-1.34056",
  "segments-query-core": "static-1.1425",
  "demographics-service-types": "static-1.1658",
  "eligibility-engine-service-types": "static-1.3190",
  "automation-ui-ubb": "static-1.5734",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7345",
  "data-token-views": "static-1.16403",
  "forms-utils-lib": "static-1.12598",
  "payments-embed-points-lib": "static-1.13048",
  "simple-menus-core": "static-1.15138",
  "simple-menus-lib": "static-1.16655",
  "videoconference-integration-components": "static-1.6829",
  "marketing-contacts-client": "static-1.7524",
  "automation-applications-service-types": "static-1.3513",
  "automation-platform-service-types": "static-1.2593",
  "ContentEditorUI": "static-2.77129",
  "short-messages-app-service-client": "static-1.3976",
  "web-interactives-components": "static-1.13775",
  "web-interactives-data": "static-1.13776",
  "messaging-shared-utils-lib": "static-1.596",
  "messaging-user-info-utils-lib": "static-1.766",
  "email-portal-health-service-types": "static-1.983",
  "line-items-api": "static-1.704",
  "commerce-totals-service-types": "static-1.3822",
  "FireAlarmUi": "static-1.4516",
  "sales-templates-service-types-lib": "static-1.4173",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21754",
  "automation-ui-usage-tracking": "static-1.21217",
  "data-studio-ubb": "static-1.2737",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.27040",
  "collaboration-sidebar": "static-1.57824",
  "content-management-data-lib": "static-1.5393",
  "copilot-plugins": "static-1.11122",
  "cta-picker": "static-1.36411",
  "customer-agent-discovery-components-lib": "static-1.3094",
  "editor-components": "static-1.13237",
  "editor-iframe-lib": "static-1.8411",
  "error-messaging-js": "static-1.5199",
  "FormsCommonComponents": "static-1.85860",
  "pictos": "static-7.184",
  "react-transition-group": "static-2.65",
  "redux-request-state": "static-1.10652",
  "SharedLegalStrings": "static-1.1754",
  "smart-content-core": "static-1.42452",
  "smart-content-lib": "static-1.43105",
  "social-composer-lib": "static-1.59136",
  "structured-content-lib": "static-1.25200",
  "theme-previewer-lib": "static-1.53266",
  "tinymce-copilot": "static-1.16446",
  "xray-recommendation-lib": "static-1.7913",
  "automation-ui-routing": "static-1.21175",
  "sql-reporting-client-types": "static-1.5646",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.42209",
  "campaigns-utils-lib": "static-1.3185",
  "reporting-enablement": "static-1.22940",
  "chatspot-widget-iframe": "static-1.21342",
  "collaboration-sidebar-common": "static-1.2621",
  "forms-ai-lib": "static-1.4330",
  "codemirror-dlb": "static-1.58688",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6437",
  "report-customization-components": "static-1.13190",
  "data-quality-ui-library": "static-1.13048",
  "html-to-image": "static-1.54",
  "reporting-filters": "static-1.339",
  "reporting-insights-lib": "static-1.1759"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.12278",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.466",
  "data-fetching-client": "/data-fetching-client/static-1.9675",
  "foundations-components": "/foundations-components/static-1.7949",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.974",
  "foundations-theming": "/foundations-theming/static-1.4423",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.82",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8019",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9973",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11477",
  "I18n": "/I18n/static-7.1628",
  "jasmine-runner": "/jasmine-runner/static-1.6470",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.12339",
  "quartz": "/quartz/static-1.7040",
  "react-dlb": "/react-dlb/static-1.79",
  "react-rhumb": "/react-rhumb/static-1.16678",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2864",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9500",
  "settings-ui-lib": "/settings-ui-lib/static-1.12527",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7150",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11155",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9548",
  "unified-auth": "/unified-auth/static-1.499",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.781",
  "usage-tracker": "/usage-tracker/static-1.7350",
  "usage-tracker-core": "/usage-tracker-core/static-1.7200",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8096",
  "hub-http": "/hub-http/static-1.6228",
  "integrations-lib": "/integrations-lib/static-1.16154",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19727",
  "property-management-iframe": "/property-management-iframe/static-1.13164",
  "quartz-config": "/quartz-config/static-1.818",
  "quartz-core": "/quartz-core/static-1.6259",
  "quartz-routing": "/quartz-routing/static-1.470",
  "quick-fetch": "/quick-fetch/static-1.3920",
  "react": "/react/static-7.186",
  "rpc-client-utils": "/rpc-client-utils/static-1.4658",
  "ts-schema": "/ts-schema/static-1.4083",
  "ui-universal-auth": "/ui-universal-auth/static-1.8985",
  "UIComponents": "/UIComponents/static-3.8423",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.79",
  "metrics-js": "/metrics-js/static-1.9637",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3402",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3317",
  "quartz-webpack": "/quartz-webpack/static-1.3264",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.118",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4218",
  "floating-ui": "/floating-ui/static-1.56",
  "foundations-assets": "/foundations-assets/static-1.4871",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2139",
  "framer-motion": "/framer-motion/static-1.72",
  "hs-story-utils": "/hs-story-utils/static-1.9431",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.26",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-utils": "/react-utils/static-2.5348",
  "react-virtualized": "/react-virtualized/static-2.99",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "tanstack-table": "/tanstack-table/static-1.55",
  "trellis-assets": "/trellis-assets/static-1.1962",
  "ui-fonts": "/ui-fonts/static-1.739",
  "ui-images": "/ui-images/static-2.1156",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2906",
  "foundations-theming-base": "/foundations-theming-base/static-1.3408",
  "stylex": "/stylex/static-1.33",
  "HeadJS": "/HeadJS/static-2.762",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3130",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4333",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8995",
  "ai-rendering-library": "/ai-rendering-library/static-1.10188",
  "chirp-fetch": "/chirp-fetch/static-1.1894",
  "connections-embed-lib": "/connections-embed-lib/static-1.1003",
  "copilot-toolkit": "/copilot-toolkit/static-1.11149",
  "feedback-loader": "/feedback-loader/static-1.29308",
  "laboratory-lib": "/laboratory-lib/static-3.7162",
  "marketplace-embed": "/marketplace-embed/static-1.22099",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9623",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19683",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13898",
  "sanitize-text": "/sanitize-text/static-1.8148",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8709",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5764",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5036",
  "wootric-nps": "/wootric-nps/static-1.6982",
  "quartz-head": "/quartz-head/static-1.705",
  "web-vitals": "/web-vitals/static-1.5",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4657",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4161",
  "highcharts": "/highcharts/static-8.104",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "reporting-data": "/reporting-data/static-1.67567",
  "cssUtils": "/cssUtils/static-1.794",
  "flux-actions": "/flux-actions/static-1.338",
  "HubStyle": "/HubStyle/static-2.11784",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10213",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10371",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7340",
  "icons": "/icons/static-2.647",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.18260",
  "storybook-react": "/storybook-react/static-1.33",
  "trellis-story-utils": "/trellis-story-utils/static-1.4522",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5432",
  "quartz-i18n": "/quartz-i18n/static-1.715",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.247",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.366",
  "slack-ui-library": "/slack-ui-library/static-1.10399",
  "fsm": "/fsm/static-1.3736",
  "customer-data-objects": "/customer-data-objects/static-1.7675",
  "property-translator": "/property-translator/static-1.5407",
  "hs-locale-management": "/hs-locale-management/static-1.84",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7934",
  "hs-promise-utils": "/hs-promise-utils/static-1.5598",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4885",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13569",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5607",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7788",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4483",
  "superstore": "/superstore/static-1.4767",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10169",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7897",
  "hub-http-janus": "/hub-http-janus/static-1.836",
  "hubspotter-http": "/hubspotter-http/static-1.4655",
  "immutable-less": "/immutable-less/static-1.4660",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17134",
  "nav-meta": "/nav-meta/static-1.29696",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10254",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18003",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3849",
  "property-management-common": "/property-management-common/static-1.5452",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9064",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.536",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.715",
  "quartz-test": "/quartz-test/static-1.715",
  "quartz-tracking": "/quartz-tracking/static-1.419",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.68",
  "bender-build-tools": "/bender-build-tools/static-1.3205",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.21351",
  "ContentUtils": "/ContentUtils/static-1.68375",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13033",
  "sassPrefix": "/sassPrefix/static-1.156",
  "avatar-components": "/avatar-components/static-1.2502",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39794",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13170",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.14364",
  "ExportDialog": "/ExportDialog/static-6.10395",
  "highlight.js": "/highlight.js/static-1.79",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.41321",
  "reporting-snowflake": "/reporting-snowflake/static-1.56185",
  "reporting-ui-components": "/reporting-ui-components/static-2.64838",
  "reporting-visualizations": "/reporting-visualizations/static-1.59643",
  "ui-addon-teams": "/ui-addon-teams/static-1.21561",
  "magpie-lib": "/magpie-lib/static-1.5555",
  "navigation-components": "/navigation-components/static-1.18059",
  "magpie-types": "/magpie-types/static-1.5015",
  "simple-logging-lib": "/simple-logging-lib/static-1.3056",
  "ai-studio-lib": "/ai-studio-lib/static-1.11623",
  "app-governance-lib": "/app-governance-lib/static-1.1549",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10515",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8004",
  "ui-product-approvals": "/ui-product-approvals/static-1.28154",
  "ui-tool-access": "/ui-tool-access/static-1.10153",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8905",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5767",
  "usage-tracker-public": "/usage-tracker-public/static-1.7161",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3589",
  "persist-promise": "/persist-promise/static-1.3704",
  "reference-resolvers": "/reference-resolvers/static-1.8177",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3931",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.344",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3018",
  "final-form": "/final-form/static-1.70",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2789",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "atom": "/atom/static-1.5078",
  "purchase-motions-components": "/purchase-motions-components/static-1.5913",
  "salesImages": "/salesImages/static-1.525",
  "batch-promise": "/batch-promise/static-1.1547",
  "crm-component-utils": "/crm-component-utils/static-1.39086",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5891",
  "customer-data-properties": "/customer-data-properties/static-1.51564",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6891",
  "property-value-citations": "/property-value-citations/static-1.2178",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8100",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9061",
  "navigation-messaging": "/navigation-messaging/static-1.7386",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9971",
  "cms-field-types": "/cms-field-types/static-1.4818",
  "content-icons-ui": "/content-icons-ui/static-1.2229",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9833",
  "events-data-lib": "/events-data-lib/static-1.227",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7253",
  "crm-message-bus": "/crm-message-bus/static-1.43000",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22229",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4725",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4008",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6796",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.986",
  "onboarding-tours": "/onboarding-tours/static-1.16620",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13693",
  "academy-common-lib": "/academy-common-lib/static-1.13824",
  "content-assistance-lib": "/content-assistance-lib/static-1.7762",
  "dashboard-lib": "/dashboard-lib/static-1.81550",
  "file-manager-components": "/file-manager-components/static-1.23643",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18477",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18243",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18235",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19849",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8708",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4768",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11041",
  "user-context": "/user-context/static-1.5111",
  "growth-payments-core": "/growth-payments-core/static-1.25389",
  "reporting-plugins": "/reporting-plugins/static-1.10336",
  "reporting-reports": "/reporting-reports/static-1.67245",
  "idb-keyval": "/idb-keyval/static-1.44",
  "reactive-lib": "/reactive-lib/static-1.730",
  "nest": "/nest/static-1.232",
  "codemirror": "/codemirror/static-5.95",
  "react-codemirror": "/react-codemirror/static-1.10633",
  "framework-listing-lib": "/framework-listing-lib/static-2.28716",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30726",
  "apps-service-types": "/apps-service-types/static-1.3884",
  "oauth-service-types": "/oauth-service-types/static-1.4255",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.49",
  "onboarding-scopes": "/onboarding-scopes/static-1.6468",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4834",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7672",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14944",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3600",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9271",
  "redux-thunk": "/redux-thunk/static-2.43",
  "purchase-motions-api": "/purchase-motions-api/static-1.5916",
  "signup-constants": "/signup-constants/static-1.18848",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8055",
  "trials-service-types": "/trials-service-types/static-1.3909",
  "card-properties-lib": "/card-properties-lib/static-1.44203",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.37129",
  "crm-actions": "/crm-actions/static-1.6331",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43596",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9300",
  "customer-data-tracking": "/customer-data-tracking/static-1.6895",
  "hs-resources": "/hs-resources/static-1.156",
  "pulse": "/pulse/static-1.580",
  "calling-global-api": "/calling-global-api/static-1.64523",
  "calling-internal-common": "/calling-internal-common/static-1.31309",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65905",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58199",
  "commerce-products-lib": "/commerce-products-lib/static-1.9579",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3800",
  "crm-links": "/crm-links/static-1.6300",
  "external-options-client-types": "/external-options-client-types/static-1.4162",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4226",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.637",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3694",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48759",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3968",
  "smart-property-lib": "/smart-property-lib/static-1.7067",
  "tiered-pricing": "/tiered-pricing/static-1.1233",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10996",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4142",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.10",
  "react-dnd-compat": "/react-dnd-compat/static-1.4621",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.905",
  "growth-data-modal": "/growth-data-modal/static-1.5440",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3072",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1929",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.686",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7550",
  "academy-service-client": "/academy-service-client/static-1.3687",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.39142",
  "FileManagerLib": "/FileManagerLib/static-1.39283",
  "video-embed": "/video-embed/static-1.35770",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28567",
  "redux-actions": "/redux-actions/static-3.7",
  "video-components-external": "/video-components-external/static-1.11278",
  "video-data-lib": "/video-data-lib/static-1.34936",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23547",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9894",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24384",
  "viral-links-lib": "/viral-links-lib/static-1.7068",
  "data-token-picker": "/data-token-picker/static-1.16422",
  "react-flip-move": "/react-flip-move/static-1.70",
  "nested-table": "/nested-table/static-1.233",
  "timezone-utils": "/timezone-utils/static-2.5250",
  "seat-types-lib": "/seat-types-lib/static-1.20",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17595",
  "ui-addon-opt": "/ui-addon-opt/static-4.8374",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9132",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7332",
  "customer-data-views-management": "/customer-data-views-management/static-1.25465",
  "framework-data-table": "/framework-data-table/static-2.11933",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6864",
  "nudge-client-utils": "/nudge-client-utils/static-1.2593",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1036",
  "app-users-service-client": "/app-users-service-client/static-1.5604",
  "app-users-service-types": "/app-users-service-types/static-1.5012",
  "mini-checkout-client": "/mini-checkout-client/static-1.26824",
  "onboarding-utils": "/onboarding-utils/static-1.5359",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2046",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28552",
  "edison-service-client-types": "/edison-service-client-types/static-1.394",
  "crm_data": "/crm_data/static-4.91978",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.46025",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.16185",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4262",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.19077",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18549",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10384",
  "crm-fe-perf": "/crm-fe-perf/static-1.22909",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.83",
  "directed-graph": "/directed-graph/static-1.942",
  "event-emitter": "/event-emitter/static-1.954",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "calling-error-reporting": "/calling-error-reporting/static-1.31316",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11042",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6547",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.987",
  "commerce-permissions": "/commerce-permissions/static-1.775",
  "products-iframe-lib": "/products-iframe-lib/static-1.7943",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10355",
  "data-agent-kit": "/data-agent-kit/static-1.202",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10056",
  "policy-lib": "/policy-lib/static-1.6784",
  "react-tinymce": "/react-tinymce/static-1.55252",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10119",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54378",
  "tinymce-plugins": "/tinymce-plugins/static-1.57492",
  "tinymce-themes": "/tinymce-themes/static-1.56348",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1969",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1957",
  "user-context-client": "/user-context-client/static-1.4619",
  "audio-components": "/audio-components/static-1.5925",
  "cropperjs": "/cropperjs/static-1.10",
  "FileManagerImages": "/FileManagerImages/static-1.36794",
  "urlinator": "/urlinator/static-1.4543",
  "video-components": "/video-components/static-1.13281",
  "outpost": "/outpost/static-1.4188",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6587",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12312",
  "content-media-compositions": "/content-media-compositions/static-2.16319",
  "media-bridge-lib": "/media-bridge-lib/static-1.18939",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6111",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5088",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3646",
  "draft-convert": "/draft-convert/static-2.73",
  "draft-extend": "/draft-extend/static-3.75",
  "draft-js": "/draft-js/static-5.78",
  "draft-plugins": "/draft-plugins/static-2.21692",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3849",
  "ts-utils-lib": "/ts-utils-lib/static-1.179",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.665",
  "crm-export-dialog": "/crm-export-dialog/static-1.6300",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6447",
  "crm-view-components": "/crm-view-components/static-1.260",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "tanstack-virtual": "/tanstack-virtual/static-1.30",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2350",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2669",
  "whisper-core-api": "/whisper-core-api/static-1.6631",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14822",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5558",
  "settings-content-modals": "/settings-content-modals/static-1.46090",
  "crm_universal": "/crm_universal/static-1.22022",
  "customer-data-email": "/customer-data-email/static-1.18049",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.37186",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39552",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.12067",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54739",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21479",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17862",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.72057",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5349",
  "utility-belt": "/utility-belt/static-1.2541",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22887",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7520",
  "customer-data-rte": "/customer-data-rte/static-1.33005",
  "cv-backend-services": "/cv-backend-services/static-1.1552",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5740",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5114",
  "qrcode-generator": "/qrcode-generator/static-1.69",
  "quotes-client-types": "/quotes-client-types/static-1.38147",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35764",
  "sales-views-client-types": "/sales-views-client-types/static-1.4265",
  "hub-http-contrib": "/hub-http-contrib/static-1.3049",
  "interframe": "/interframe/static-3.4766",
  "tinymce-data": "/tinymce-data/static-1.40463",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5217",
  "layout-dnd-components": "/layout-dnd-components/static-1.12462",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11437",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15293",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9062",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7611",
  "social-insights-client-types": "/social-insights-client-types/static-1.22122",
  "js-cookie": "/js-cookie/static-1.18",
  "ably": "/ably/static-2.2",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4146",
  "checkout-sdk": "/checkout-sdk/static-3.23667",
  "checkout-service-types": "/checkout-service-types/static-1.3824",
  "company-details-components": "/company-details-components/static-1.6202",
  "payment-method-components": "/payment-method-components/static-1.6914",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.14025",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3473",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3526",
  "access-control-lib": "/access-control-lib/static-1.10442",
  "EmailComponents": "/EmailComponents/static-1.54755",
  "EmailData": "/EmailData/static-1.53432",
  "redux-less": "/redux-less/static-2.9489",
  "sequences-lib": "/sequences-lib/static-1.8056",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10356",
  "products-ui-components": "/products-ui-components/static-1.40097",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.7077",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54755",
  "commerce-products-api": "/commerce-products-api/static-1.2304",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56813",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102735",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80778",
  "stripe-connect-js": "/stripe-connect-js/static-1.68",
  "draft-content-plugins": "/draft-content-plugins/static-1.28276",
  "ContentData": "/ContentData/static-1.68450",
  "layout-data-lib": "/layout-data-lib/static-1.9762",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.802",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3945",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3995",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.561",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18598",
  "pricing-pages-api": "/pricing-pages-api/static-1.13890",
  "ContentComponents": "/ContentComponents/static-2.71331",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.10054",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1919",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.46285",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.1147",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18900",
  "automation-ui-types": "/automation-ui-types/static-1.19818",
  "messaging-types-lib": "/messaging-types-lib/static-1.46022",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4511",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7913",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.533",
  "price-books-api": "/price-books-api/static-1.747",
  "price-books-components": "/price-books-components/static-1.805",
  "property-description-translator": "/property-description-translator/static-1.3851",
  "ramp-editor": "/ramp-editor/static-1.167",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3634",
  "totals-ui-components": "/totals-ui-components/static-1.23608",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9258",
  "advanced-menus-core": "/advanced-menus-core/static-1.15139",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12078",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34056",
  "segments-query-core": "/segments-query-core/static-1.1425",
  "demographics-service-types": "/demographics-service-types/static-1.1658",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3190",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5734",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7345",
  "data-token-views": "/data-token-views/static-1.16403",
  "forms-utils-lib": "/forms-utils-lib/static-1.12598",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.13048",
  "simple-menus-core": "/simple-menus-core/static-1.15138",
  "simple-menus-lib": "/simple-menus-lib/static-1.16655",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6829",
  "marketing-contacts-client": "/marketing-contacts-client/static-1.7524",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3513",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2593",
  "ContentEditorUI": "/ContentEditorUI/static-2.77129",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3976",
  "web-interactives-components": "/web-interactives-components/static-1.13775",
  "web-interactives-data": "/web-interactives-data/static-1.13776",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.596",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.766",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.983",
  "line-items-api": "/line-items-api/static-1.704",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3822",
  "FireAlarmUi": "/FireAlarmUi/static-1.4516",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4173",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21754",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.21217",
  "data-studio-ubb": "/data-studio-ubb/static-1.2737",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.27040",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57824",
  "content-management-data-lib": "/content-management-data-lib/static-1.5393",
  "copilot-plugins": "/copilot-plugins/static-1.11122",
  "cta-picker": "/cta-picker/static-1.36411",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.3094",
  "editor-components": "/editor-components/static-1.13237",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8411",
  "error-messaging-js": "/error-messaging-js/static-1.5199",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85860",
  "pictos": "/pictos/static-7.184",
  "react-transition-group": "/react-transition-group/static-2.65",
  "redux-request-state": "/redux-request-state/static-1.10652",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1754",
  "smart-content-core": "/smart-content-core/static-1.42452",
  "smart-content-lib": "/smart-content-lib/static-1.43105",
  "social-composer-lib": "/social-composer-lib/static-1.59136",
  "structured-content-lib": "/structured-content-lib/static-1.25200",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.53266",
  "tinymce-copilot": "/tinymce-copilot/static-1.16446",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7913",
  "automation-ui-routing": "/automation-ui-routing/static-1.21175",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5646",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.42209",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3185",
  "reporting-enablement": "/reporting-enablement/static-1.22940",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.21342",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2621",
  "forms-ai-lib": "/forms-ai-lib/static-1.4330",
  "codemirror-dlb": "/codemirror-dlb/static-1.58688",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6437",
  "report-customization-components": "/report-customization-components/static-1.13190",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.13048",
  "html-to-image": "/html-to-image/static-1.54",
  "reporting-filters": "/reporting-filters/static-1.339",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1759"
}
};
